import { createSlice } from '@reduxjs/toolkit'
import { saveUrlParams } from '../actions/urlParamActions'
import {
  AdAuditLogRequestParams,
  AdBreaksRequestParams,
  AdPodsRequestParams,
  AdServersRequestParams,
  OverlaysRequestParams,
  AlarmsRequestParams,
  AppliancesRequestParams,
  GroupListRequestParams,
  GroupsRequestParams,
  InputsRequestParams,
  KubernetesNodesRequestParams,
  NetworksRequestParams,
  OutputListRequestParams,
  OutputsRequestParams,
  PaginatedRequestParams,
  PortsRequestParams,
  ServicesRequestParams,
  TransformationProfilesRequestParams,
  TunnelsRequestParams,
  UsersRequestParams,
} from '../../api/nm-types'
import { logoutUser } from '../actions/userActions'

interface State {
  cachedUrlParams: UrlParamCache
}

export interface UrlParamCache {
  adAuditLog?: AdAuditLogRequestParams
  adCreatives?: AdAuditLogRequestParams
  adPods?: AdPodsRequestParams
  adBreaks?: AdBreaksRequestParams
  adServers?: AdServersRequestParams
  overlays?: OverlaysRequestParams
  adBreakControlInputs?: InputsRequestParams
  addressMappings?: PaginatedRequestParams
  alarms?: AlarmsRequestParams
  appliances?: AppliancesRequestParams
  groups?: GroupsRequestParams
  groupLists?: GroupListRequestParams
  inputs?: InputsRequestParams
  interfaces?: PortsRequestParams
  k8sNodes?: KubernetesNodesRequestParams
  k8sServices?: ServicesRequestParams
  networks?: NetworksRequestParams
  outputs?: OutputsRequestParams
  outputLists?: OutputListRequestParams
  regions?: PaginatedRequestParams
  streamManager?: Record<string, string>
  transformationProfiles?: TransformationProfilesRequestParams
  tunnels?: TunnelsRequestParams
  users?: UsersRequestParams
}

const initialState: State = {
  cachedUrlParams: {},
}
const slice = createSlice({
  name: 'urlParam',
  initialState: { ...initialState },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveUrlParams, (state, { payload: { key, urlParams } }): typeof initialState => {
        return {
          ...state,
          cachedUrlParams: {
            ...state.cachedUrlParams,
            [key]: urlParams,
          },
        }
      })
      .addCase(logoutUser.fulfilled, (): State => initialState)
  },
})

export default slice.reducer
